module.exports = __webpack_public_path__ + "img/slide-17-2.974cfe37.png";